/**
 * In this file, we create a React component
 * which incorporates components provided by Material-UI.
 */
import React from 'react'
import queryString from 'query-string'

import { WithLocalize } from '../../containers/I18nProvider';
import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage'
import ServiceApi from '../../services/ServiceApi'

import './style.scss'
import logo from './img/logo-entel-header.png'
import homeIcon from './img/icono-home.png'
import point from './img/point.png'
import logoFooter from './img/logo-entel.png'
import LoginForm from './LoginForm'

class Login extends React.Component {
  constructor(props, context) {
    super(props, context)

    this.api = new ServiceApi(this)
    this.parameters = queryString.parse(props.location.search)
    props.changeDefaultLocale('es');
  }

  _validateParams() {
    if (
      !this.parameters.client_id ||
      !this.parameters.redirect_uri ||
      !this.parameters.response_type
    ) {
      return false
    }
    return true
  }

  componentDidMount() {
    //document.body.className = 'entel-body';
    document.title = 'Entel Go - Login'
  }

  render() {
    const { translate } = this.props

    return (
      <div>
        <div className='container-fluid entel-header'>
          <div className='container'>
            <div className='row'>
              <div className='col-xs-12 col-sm-4 logoContainer'>
                <img src={logo} alt='logo' className='logoHeader' />
              </div>
              <div className='row hidden-xs'>
                <div className='col-sm-9 containerTitle'>
                  <h3>
                    Para disfrutar el contenido exclusivo de este canal, debes
                    tenerlo contratado en tu servicio de <br></br>
                    <span className='entel-bold'>Televisión Entel.</span>
                  </h3>
                </div>
                <div className='col-sm-3'>
                  <img src={homeIcon} alt='home' className='logoHome' />
                </div>
              </div>
            </div>
            <div className='row visible-xs'>
              <div className='col-sm-3'>
                <img
                  className='homeIcon'
                  src={homeIcon}
                  alt=''
                />
              </div>
              <div className='col-sm-9'>
                <h3>
                  Para disfrutar el contenido exclusivo de este canal, debes
                  tenerlo contratado en tu servicio de
                  <span className='entel-bold'>Televisión Entel.</span>
                </h3>
              </div>
            </div>
            <div className='point'>
              <img src={point} alt='point' />
            </div>
          </div>
        </div>
        <main>
          {this._validateParams() ? (
            <LoginForm api={this.api} location={this.props.location} />
          ) : (
            <RequestLoginErrorMessage
              onlyMessage={true}
              message={translate('RequestLoginErrorMessage')}
            />
          )}
        </main>
        <footer>
          <div class='container'>
            <div class='row'>
              <div class='col-xs-12 col-sm-12 col-sm-offset-3 col-md-3 col-md-offset-4 cuadro'>
                <img src={logoFooter} className='logoFooter' alt='entel' />
              </div>
            </div>
          </div>
        </footer>
      </div>
    )
  }
}

export default WithLocalize(Login);
